var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

import * as React from "react";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import styled from "styled-components";
import { Grid, Typography } from "@material-ui/core";
import * as quizAnswerActions from "../../state/quizAnswer/actions";
import * as messageActions from "../../state/message/actions";
import { initialize } from "../../state/actions";
import Checkbox from "../CheckboxOption";
import Feedback from "../Feedback";
import MultipleChoice from "../MultipleChoice";
import ResearchAgreement from "../ResearchAgreement";
import Scale from "../Scale";
import Open from "../Open";
import Essay from "../Essay";
import StageVisualizer from "../PeerReviews/StageVisualizer";
import PeerReviews from "../PeerReviews";
import Unsupported from "../Unsupported";
import ResultInformation from "./ResultInformation";
import { useTypedSelector } from "../../state/store";
import Deadline from "./Deadline";
import LoadingQuiz from "./LoadingQuiz";
import TopInfoBar from "./TopInfoBar";
import SubmitButton from "./SubmitButton";
import LoginPrompt from "./LoginPrompt";
import MarkdownText from "../MarkdownText";

var componentsByTypeNames = function componentsByTypeNames(typeName) {
  var mapTypeToComponent = {
    essay: Essay,
    "multiple-choice": MultipleChoice,
    scale: Scale,
    checkbox: Checkbox,
    open: Open,
    "research-agreement": ResearchAgreement,
    feedback: Feedback,
    "custom-frontend-accept-data": Unsupported
  };
  return mapTypeToComponent[typeName];
};

var QuizItemContainerDiv = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  padding-bottom: 20px;\n"], ["\n  padding-bottom: 20px;\n"])));
var ComponentWrapper = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  background-color: ", ";\n  border-radius: 10px;\n  padding: 1rem 2rem 1rem 1rem;\n"], ["\n  background-color: ", ";\n  border-radius: 10px;\n  padding: 1rem 2rem 1rem 1rem;\n"])), function (props) {
  return props.rowNumber % 2 === 0 ? "inherit" : "#605c980d";
});
var QuizContentWrapper = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  padding: 1rem;\n  ", "\n"], ["\n  padding: 1rem;\n  ", "\n"])), function (_a) {
  var disabled = _a.disabled;
  return disabled && "\n        opacity: 0.6;\n        cursor: default;\n      ";
});
var OuterDiv = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  p {\n    margin-bottom: 0 !important;\n  }\n  ul {\n    padding-inline-start: 30px;\n  }\n"], ["\n  p {\n    margin-bottom: 0 !important;\n  }\n  ul {\n    padding-inline-start: 30px;\n  }\n"])));
var BoldTypography = styled(Typography)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  font-weight: bold;\n  padding-bottom: 20px;\n"], ["\n  font-weight: bold;\n  padding-bottom: 20px;\n"])));

var FuncQuizImpl = function FuncQuizImpl(_a) {
  var id = _a.id,
      languageId = _a.languageId,
      accessToken = _a.accessToken,
      backendAddress = _a.backendAddress,
      customContent = _a.customContent,
      fullInfoWithoutLogin = _a.fullInfoWithoutLogin,
      _b = _a.showZeroPointsInfo,
      showZeroPointsInfo = _b === void 0 ? true : _b;
  var submitLocked = useTypedSelector(function (state) {
    return state.quizAnswer.submitLocked;
  });
  var messageState = useTypedSelector(function (state) {
    return state.message;
  });
  var quizAnswer = useTypedSelector(function (state) {
    return state.quizAnswer.quizAnswer;
  });
  var quiz = useTypedSelector(function (state) {
    return state.quiz;
  });
  var languageInfo = useTypedSelector(function (state) {
    return state.language.languageLabels;
  });
  var userQuizState = useTypedSelector(function (state) {
    return state.user.userQuizState;
  });
  var storeAccessToken = useTypedSelector(function (state) {
    return state.user.accessToken;
  });
  var quizDisabled = useTypedSelector(function (state) {
    return state.quizAnswer.quizDisabled;
  });
  var showPoints = useTypedSelector(function (state) {
    return state.customization.showPointsInfo;
  });
  var dispatch = useDispatch();
  var error = messageState.errorMessage;
  useEffect(function () {
    dispatch(initialize(id, languageId, accessToken, backendAddress, fullInfoWithoutLogin, showZeroPointsInfo));
  }, [id, languageId, accessToken, backendAddress]);

  if (!accessToken && !fullInfoWithoutLogin) {
    return React.createElement("div", null, React.createElement(TopInfoBar, {
      staticBars: true
    }), React.createElement(LoginPrompt, {
      content: customContent
    }));
  }

  var loggedInButNotSetInStore = accessToken && !storeAccessToken;

  if (loggedInButNotSetInStore || !quiz) {
    return React.createElement(LoadingQuiz, {
      content: customContent,
      accessToken: accessToken
    });
  }

  if (!languageInfo) {
    return React.createElement("div", null, "language info not set");
  }

  var generalLabels = languageInfo.general;

  var quizItemComponents = function quizItemComponents(quiz, languageId) {
    return React.createElement(React.Fragment, null, quiz.items.sort(function (i1, i2) {
      return i1.order - i2.order;
    }).map(function (item, idx) {
      var ItemComponent = componentsByTypeNames(item.type);
      return React.createElement(ComponentWrapper, {
        rowNumber: idx,
        key: item.id
      }, React.createElement(ItemComponent, {
        item: item
      }));
    }));
  };

  if (error) {
    return React.createElement("div", null, generalLabels && generalLabels.errorLabel, React.createElement("pre", null, error));
  }

  if (quiz.texts.length === 0) {
    var message = "Error: quiz has no texts. (Likely the quiz does not match the requested " + "language id)";
    dispatch(messageActions.setErrorMessage(message));
    return React.createElement("div", null);
  }

  var triesRemaining = quiz.tries;
  var stillSubmittable = true;

  if (quiz.triesLimited) {
    var triesUsed = 0;

    if (userQuizState) {
      triesUsed = userQuizState.tries;
    }

    triesRemaining -= triesUsed;

    if (triesRemaining <= 0) {
      stillSubmittable = false;
    }
  }

  var locked = false;

  if (userQuizState) {
    locked = userQuizState.status === "locked";
  }

  if (locked || quizDisabled) {
    stillSubmittable = false;
  }

  var containsPeerReviews = quiz.peerReviewCollections !== null && quiz.peerReviewCollections.length > 0;
  var answerStatus = quizAnswer.status ? quizAnswer.status : null;
  var shouldShowPeerReviews = userQuizState ? userQuizState.status === "locked" ? answerStatus === "rejected" || answerStatus === "spam" ? false : true : false : false;
  var exerciseFinishedMessage = userQuizState && userQuizState.status === "locked" ? answerStatus === "rejected" ? languageInfo.peerReviews.answerRejected : answerStatus === "spam" ? languageInfo.peerReviews.answerFlaggedAsSpam : answerStatus === "confirmed" ? languageInfo.peerReviews.answerConfirmed : null : null;
  var showPointsPolicyLabel = !quiz.awardPointsEvenIfWrong && quiz.items.length > 1 && showPoints && quiz.items.some(function (qi) {
    return qi.type !== "checkbox" && qi.type !== "scale" && qi.type !== "feedback" && qi.type !== "research-agreement";
  });
  return React.createElement(OuterDiv, null, React.createElement(TopInfoBar, null), quizDisabled && React.createElement(LoginPrompt, {
    content: customContent,
    fullQuizInfoShown: true
  }), React.createElement(QuizContentWrapper, {
    disabled: quizDisabled
  }, React.createElement(Deadline, {
    deadline: quiz.deadline
  }), containsPeerReviews && React.createElement(StageVisualizer, null), React.createElement(MarkdownText, null, quiz.texts[0].body), React.createElement(QuizItemContainerDiv, null, quizItemComponents(quiz, languageId)), !stillSubmittable && !quizDisabled ? React.createElement(React.Fragment, null, containsPeerReviews && exerciseFinishedMessage && React.createElement(BoldTypography, null, exerciseFinishedMessage), containsPeerReviews && shouldShowPeerReviews && React.createElement(PeerReviews, null), React.createElement(ResultInformation, {
    quiz: quiz,
    quizAnswer: quizAnswer,
    generalLabels: generalLabels
  })) : React.createElement("div", null, messageState.notification && messageState.notification.message && React.createElement(Typography, {
    style: {
      color: messageState.notification.color,
      fontSize: "1.25rem"
    }
  }, messageState.notification.message), React.createElement(Grid, {
    container: true,
    alignItems: "center",
    spacing: 2
  }, React.createElement(Grid, {
    item: true,
    onClick: function onClick(e) {
      if (submitLocked && !quizDisabled) {
        dispatch(quizAnswerActions.noticeDisabledSubmitAttempt());
      }
    },
    xs: "auto"
  }, React.createElement(SubmitButton, null)), !quizDisabled && React.createElement(Grid, {
    item: true,
    xs: "auto"
  }, quiz.deadline && new Date(quiz.deadline).getTime() < new Date().getTime() ? React.createElement(Typography, null, generalLabels.pastDeadline) : React.createElement(React.Fragment, null, React.createElement(Typography, null, quiz.triesLimited ? generalLabels.triesRemainingLabel + ": " + triesRemaining : generalLabels.triesNotLimitedLabel), showPointsPolicyLabel && React.createElement(Typography, null, generalLabels.pointsGrantingPolicyInformer(quiz.grantPointsPolicy))))))));
};

export default FuncQuizImpl;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;